import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchCustomersQuery } from '@/features/customers'
import { fetchCustomersList } from '@/features/customers/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'
import { CustomersSearchSchema } from '@/routes/_protected/$tenantKey/settings/customers/-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/customers/'
)({
  validateSearch: (search) => parse(CustomersSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、選択中のDCと enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId,
          enable: true
        }
      })
    }

    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchCustomersQuery(tenantKey, deps)

    return {
      authUser: auth.user,
      customers: await fetchCustomersList(query, abortController.signal)
    }
  }
})
